export default __webpack_public_path__ + "static/hindidiwas2-4440260d26f8b81a438e870ac56b9c5c.jpg";